import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { VariableNode } from 'services/entities/VariablesEntity';
import type { RootState } from './Store.ts';

type EditorRectType = { top: number; left: number; width: number };
export interface ContextMenuState {
  lastContextMenuPosition: { x: number; y: number; editorRect: EditorRectType } | null;
  lastCopiedVariable: VariableNode | null;
  canPaste: boolean;
}

const initialState: ContextMenuState = {
  lastContextMenuPosition: null,
  lastCopiedVariable: null,
  canPaste: false,
};

const contextMenuSlice = createSlice({
  name: 'contextMenu',
  initialState,
  reducers: {
    setCanPaste: (state, action: PayloadAction<boolean>) => {
      state.canPaste = action.payload;
    },
    setLastContextMenuPosition(state, action: PayloadAction<{ x: number; y: number; editorRect: EditorRectType } | null>) {
      state.lastContextMenuPosition = action.payload;
    },
    setLastCopiedVariable(state, action: PayloadAction<VariableNode | null>) {
      state.lastCopiedVariable = action.payload;
    },
  },
});

export const { setLastContextMenuPosition, setCanPaste, setLastCopiedVariable } = contextMenuSlice.actions;
export const selectCanPaste = (state: RootState) => state.contextMenu.canPaste;
export const selectLastCopiedVariable = (state: RootState) => state.contextMenu.lastCopiedVariable;
export default contextMenuSlice.reducer;
